import { showToast } from '@helpers/showToast';

import useTranslation from '@hooks/useTranslation';

import { useLiveTranslateMutation } from '@services/useLiveTranslateMutation';

import {
  selectAITranslateNetworkAiTextBlocks,
  selectAITranslateTargetLanguage,
  useAITranslateActions,
} from '../store/useAITranslateStore';

interface ITranslateParams {
  item: any;
  fields: string[];
  translationFields: string[];
  entityName?: string;
  entityId?: string | number;
}

type TValue = { [key: string]: string };

const useLiveTranslateNetworkTextBlocks = ({
  item,
  fields,
  translationFields,
  entityName = 'action_list',
  entityId,
}: ITranslateParams) => {
  const { t } = useTranslation();
  const { mutate: liveTranslateMutation, isLoading: isInfoTranslateLoading } = useLiveTranslateMutation();

  const targetLanguage = selectAITranslateTargetLanguage();
  const translates = selectAITranslateNetworkAiTextBlocks();
  const { setAITranslateNetworkAiTextBlocks } = useAITranslateActions();

  let hasTranslate = false;

  if (
    Object.keys(item?.translates || {}).length &&
    item?.translates?.[targetLanguage]?.['description']?.sourceLanguage !== targetLanguage
  ) {
    hasTranslate = true;
  }

  const toggleIsTranslate = () => {
    if (!translates['description'] && !item.translates?.[targetLanguage]?.['description']) {
      const uniqKey = window.btoa(JSON.stringify(fields) + targetLanguage);

      liveTranslateMutation(
        {
          fields: ['description'],
          entity_name: entityName,
          entity_id: entityId,
          target_language: targetLanguage,
          source_language: '',
          key: uniqKey,
        },
        {
          onSuccess: ({ data }) => {
            if (!data.translation.length && !data.translation) {
              showToast({ variant: 'error', message: t('Translation error') });

              return;
            }

            const newTransObj: TValue = {};

            if (Object.keys(data?.translation).length) {
              translationFields.forEach((field) => {
                newTransObj[field] = data.translation[field]?.text || item[field];
              });
            }

            setAITranslateNetworkAiTextBlocks(newTransObj);
          },
        },
      );
    }
  };

  return {
    hasTranslate,
    isTranslateLoading: isInfoTranslateLoading,
    toggleIsTranslate,
  };
};

export default useLiveTranslateNetworkTextBlocks;
